import { Conversation } from './types/Conversation';
import { MakeCall } from './createMakeCall';

const acceptTenant = (makeCall: MakeCall) => (conversationId: number) =>
  makeCall<Conversation>(
    'PUT',
    `/api/v2/conversation/${conversationId}/accept-tenant`,
  );
export { acceptTenant };
